// Next.js Pages Router returns this filesystem route pattern for both bare login and its mode variants.
export const isLoginRoute = (routePattern: string) => routePattern === '/login/[[...mode]]'
